import { get } from "@insite/client-framework/Services/ApiService";
import { ExternalProviderLinkCollectionModel } from "@insite/client-framework/Services/IdentityService";

export function getExternalProviders(returnUrl?: string) {
    const url = `/identity/externalproviders${returnUrl ? `?returnUrl=${returnUrl}` : ""}`;
    return get<ExternalProviderLinkCollectionModel>(url);
}
